export default defineNuxtPlugin({
  parallel: true,
  setup: nuxtApp => {
    nuxtApp.vueApp.directive('price', {
      mounted(el, binding) {
        const price = binding.value
        const { $i18n } = useNuxtApp()

        el.textContent = formatNumberWithCommas(price, $i18n.locale.value)
      },
    })
  },
})
